export var MenuMode;
(function (MenuMode) {
    MenuMode["single"] = "single";
    MenuMode["multiple"] = "multiple";
})(MenuMode || (MenuMode = {}));
